export var GameType;
(function (GameType) {
    GameType["VGC"] = "VIDEO_GAME";
    GameType["TCG"] = "TRADING_CARD_GAME";
    GameType["GO"] = "GO";
})(GameType || (GameType = {}));
